import { useModoConsultaEvaluacion } from '../../../../hooks/useModoConsultaEvaluacion';
import React, { useState, useContext } from 'react';
import styles from './m4_ejercicio7.module.scss';
import Swal from 'sweetalert2';

import { AppContext } from '../../../../Context';
import { collection, addDoc } from "firebase/firestore";
import { db } from '../../../../firebase/firebase';
import { Row, Col, Form, FormGroup, FormControl } from 'react-bootstrap';


const M4Ejercicio7 = ({ cerrarModal }) => {
  const { currentUser } = useContext(AppContext);
    const modoConsulta = useModoConsultaEvaluacion();

  const [respuestas, setRespuestas] = useState({
    hematocitos: '',
    citoplasma: '',
    leucocitos: '',
    diafragma: '',
    diapason: '',
    diafano: '',
    diametro: '',
    diarrea: '',
    boligrafo: '',
    grafologia: '',
    caligrafia: '',
    etnografia: '',
    ortografia: '',
    ciclico: '',
    bicicleta: '',
    triciclo: '',
    psicologia: '',
    biologia: '',
    macrocefalico: '',
    macroeconomia: '',
    macrobiotico: '',
    macrocosmos: '',
    neofito: '',
    neolitico: '',
    
    neonato: '',
    
    economia: '',
    astronomia: '',
    autonomo: '',
    
    pedagogia: '',
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setRespuestas(prev => ({ ...prev, [name]: value }));
  };

  const enviarResultados = async () => {
        if (modoConsulta) { cerrarModal?.(); return; }

    const emptyFields = Object.entries(respuestas).filter(([, value]) => !value.trim());
    if (emptyFields.length > 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Campos incompletos',
        text: 'Completa todos los campos obligatorios antes de enviar la evaluación.',
        confirmButtonText: 'Aceptar'
      });
      return;
    }

    try {
      await addDoc(collection(db, "evaluaciones"), {
        userId: currentUser.uid,
        nombre: "Ejercicio 7: Incrementa tu Vocabulario",
        nivel: "Basico",
        modulo: "4",
        createdAt: new Date(),
        tipo: "Texto libre",
        respuestas
      });
      Swal.fire({
        title: '¡Evaluación enviada!',
        text: 'Tus respuestas se guardaron correctamente.',
        icon: 'success',
        confirmButtonText: 'Aceptar'
      }).then((result) => {
        if (result.isConfirmed) {
          cerrarModal();
        }
      });
    } catch (error) {
      console.error("Error al enviar las respuestas: ", error);
      Swal.fire({
        icon: 'error',
        title: 'No se pudo enviar la evaluación',
        text: 'Tus respuestas no se guardaron. Verifica tu conexión e inténtalo nuevamente.',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Aceptar'
      });
    }
  };


  return (
    <div className={styles.container}>
      <h3>Nivel Básico</h3>
      <h3>Módulo 4 - Ejercicio 7</h3>
      <h5>Incrementa tu Vocabulario</h5>
      <Row>
        <Col md={6}>

          
          <Form className='border p-3'>
            <FormGroup className="mb-3">
            <p><strong>Raíz sitos, citos = célula</strong></p>
            <p> Citología: estudio de las células</p>
            <FormGroup className="mb-3">
              <div className="text-muted small mb-1">Hematocitos</div>
              <FormControl
                type="text"
                name="hematocitos"
                value={respuestas.hematocitos}
                onChange={handleChange}
              />
            </FormGroup>
            <FormGroup className="mb-3">
              <div className="text-muted small mb-1">Citoplasma</div>
              <FormControl
                type="text"
                name="citoplasma"
                value={respuestas.citoplasma}
                onChange={handleChange}
              />
            </FormGroup>
            <FormGroup className="mb-3">
              <div className="text-muted small mb-1">Leucocitos</div>
              <FormControl
                type="text"
                name="leucocitos"
                value={respuestas.leucocitos}
                onChange={handleChange}
              />
            </FormGroup>
              
            </FormGroup>


          </Form>
          <br />

          <Form className='border p-3'>
            <FormGroup className="mb-3">
            <p><strong>Prefijo: día = a través de, entre</strong></p>
            <p> Diagonal: A través del ángulo.</p>
            <FormGroup className="mb-3">
              <div className="text-muted small mb-1">Diafragma</div>
              <FormControl
                type="text"
                name="diafragma"
                value={respuestas.diafragma}
                onChange={handleChange}
              />
            </FormGroup>
            <FormGroup className="mb-3">
              <div className="text-muted small mb-1">Diapasón</div>
              <FormControl
                type="text"
                name="diapason"
                value={respuestas.diapason}
                onChange={handleChange}
              />
              <p> Diagnóstico: Determinal el conocimiento (sobre la enfermedad) a través de los síntomas</p>
            </FormGroup>
            <FormGroup className="mb-3">
              <div className="text-muted small mb-1">Diáfano</div>
              <FormControl
                type="text"
                name="diafano"
                value={respuestas.diafano}
                onChange={handleChange}
              />
            </FormGroup>
            <p> Diálogo: Intercambio de ideas a través del discurso.</p>
            <FormGroup className="mb-3">
              <div className="text-muted small mb-1">Diámetro</div>
              <FormControl
                type="text"
                name="diametro"
                value={respuestas.diametro}
                onChange={handleChange}
              />
            </FormGroup>
            <FormGroup className="mb-3">
              <div className="text-muted small mb-1">Diarrea</div>
              <FormControl
                type="text"
                name="diarrea"
                value={respuestas.diarrea}
                onChange={handleChange}
              />
            </FormGroup>
            </FormGroup>


          </Form>
          <br />

          <Form className='border p-3'>
            <FormGroup className="mb-3">
            <p><strong>Raíz grafo = escritura, descripción.</strong></p>
            
            <FormGroup className="mb-3">
              <div className="text-muted small mb-1">Bolígrafo</div>
              <FormControl
                type="text"
                name="boligrafo"
                value={respuestas.boligrafo}
                onChange={handleChange}
              />
            </FormGroup>
            <FormGroup className="mb-3">
              <div className="text-muted small mb-1">Grafología</div>
              <FormControl
                type="text"
                name="grafologia"
                value={respuestas.grafologia}
                onChange={handleChange}
              />
            </FormGroup>
            <FormGroup className="mb-3">
              <div className="text-muted small mb-1">Caligrafía</div>
              <FormControl
                type="text"
                name="caligrafia"
                value={respuestas.caligrafia}
                onChange={handleChange}
              />
            </FormGroup>
            <FormGroup className="mb-3">
              <div className="text-muted small mb-1">Etnografía</div>
              <FormControl
                type="text"
                name="etnografia"
                value={respuestas.etnografia}
                onChange={handleChange}
              />
            </FormGroup>
            <FormGroup className="mb-3">
              <div className="text-muted small mb-1">Ortografía</div>
              <FormControl
                type="text"
                name="ortografia"
                value={respuestas.ortografia}
                onChange={handleChange}
              />
            </FormGroup>
              
            </FormGroup>


          </Form>
          <br />
          
          <Form className='border p-3'>
            <FormGroup className="mb-3">

              <p><strong>Raíz idios = propio, forma particular de ser.</strong></p>
              <p>Idiosincrasia: Temperamento propio.</p>
              

            </FormGroup>


          </Form>
          <br />
          <Form className='border p-3'>
            <FormGroup className="mb-3">

              <p><strong>Raíz: kyklos = ciclos = circulo</strong></p>
              <FormGroup className="mb-3">
              <div className="text-muted small mb-1">Cíclico</div>
              <FormControl
                type="text"
                name="ciclico"
                value={respuestas.ciclico}
                onChange={handleChange}
              />
            </FormGroup>
            <FormGroup className="mb-3">
              <div className="text-muted small mb-1">Bicicleta</div>
              <FormControl
                type="text"
                name="bicicleta"
                value={respuestas.bicicleta}
                onChange={handleChange}
              />
            </FormGroup>
            <FormGroup className="mb-3">
              <div className="text-muted small mb-1">Triciclo</div>
              <FormControl
                type="text"
                name="triciclo"
                value={respuestas.triciclo}
                onChange={handleChange}
              />
            </FormGroup>

            </FormGroup>


          </Form>
          <br />


        </Col>
        <Col md={6}>
          <Form className='border p-3'>
            <FormGroup className="mb-3">
              <p><strong>Raíz: logos = tratado, estudio</strong></p>
              <p>Semiología: Estudio de la significación de las palabras y los signos.</p>
              <p>Epistemología: Estudio del conocimiento científico.</p>
              <FormGroup className="mb-3">
              <div className="text-muted small mb-1">Psicología</div>
              <FormControl
                type="text"
                name="psicologia"
                value={respuestas.psicologia}
                onChange={handleChange}
              />
            </FormGroup>
            <FormGroup className="mb-3">
              <div className="text-muted small mb-1">Biología</div>
              <FormControl
                type="text"
                name="biologia"
                value={respuestas.biologia}
                onChange={handleChange}
              />
            </FormGroup>
            </FormGroup>
          </Form>
          <br />
          <Form className='border p-3'>
            <FormGroup className="mb-3">

              <p><strong>Raíz: makro = mucho,grande</strong></p>
              <FormGroup className="mb-3">
              <div className="text-muted small mb-1">Macrocefálico</div>
              <FormControl
                type="text"
                name="macrocefalico"
                value={respuestas.macrocefalico}
                onChange={handleChange}
              />
            </FormGroup>
            <FormGroup className="mb-3">
              <div className="text-muted small mb-1">Macroeconomía</div>
              <FormControl
                type="text"
                name="macroeconomia"
                value={respuestas.macroeconomia}
                onChange={handleChange}
              />
            </FormGroup>
            <FormGroup className="mb-3">
              <div className="text-muted small mb-1">Macrobíotico</div>
              <FormControl
                type="text"
                name="macrobiotico"
                value={respuestas.macrobiotico}
                onChange={handleChange}
              />
            </FormGroup>
            <FormGroup className="mb-3">
              <div className="text-muted small mb-1">Macrocosmos</div>
              <FormControl
                type="text"
                name="macrocosmos"
                value={respuestas.macrocosmos}
                onChange={handleChange}
              />
            </FormGroup>


            </FormGroup>
          </Form>
          <br />
          <Form className='border p-3'>
            <FormGroup className="mb-3">

              <p><strong>Raíz: neo = nuevo</strong></p>
              <FormGroup className="mb-3">
              <div className="text-muted small mb-1">Neófito</div>
              <FormControl
                type="text"
                name="neofito"
                value={respuestas.neofito}
                onChange={handleChange}
              />
            </FormGroup>
            <FormGroup className="mb-3">
              <div className="text-muted small mb-1">Neolítico</div>
              <FormControl
                type="text"
                name="neolitico"
                value={respuestas.neolitico}
                onChange={handleChange}
              />
            </FormGroup>
            <p>Neomenia: Luna Nueva</p>
            <FormGroup className="mb-3">
              <div className="text-muted small mb-1">Neonato</div>
              <FormControl
                type="text"
                name="neonato"
                value={respuestas.neonato}
                onChange={handleChange}
              />
            </FormGroup>
            <p>Neofobia: Horror a todo lo nuevo.</p>
            </FormGroup>
          </Form>
          <br />
          <Form className='border p-3'>
            <FormGroup className="mb-3">

              <p><strong>Raíz: nomos = ley, regla, nómina, orden</strong></p>
              <FormGroup className="mb-3">
              <div className="text-muted small mb-1">Economía</div>
              <FormControl
                type="text"
                name="economia"
                value={respuestas.economia}
                onChange={handleChange}
              />
            </FormGroup>
            <FormGroup className="mb-3">
              <div className="text-muted small mb-1">Astronomía</div>
              <FormControl
                type="text"
                name="astronomia"
                value={respuestas.astronomia}
                onChange={handleChange}
              />
            </FormGroup>
            <FormGroup className="mb-3">
              <div className="text-muted small mb-1">Autónomo</div>
              <FormControl
                type="text"
                name="autonomo"
                value={respuestas.autonomo}
                onChange={handleChange}
              />
            </FormGroup>
            <p>Deuteronomio: segunda ley</p>

            </FormGroup>
          </Form>
          <br />
          <Form className='border p-3'>
            <FormGroup className="mb-3">

              <p><strong>Raíz: paidos = niño instrucción enseñanza</strong></p>
              <FormGroup className="mb-3">
              <div className="text-muted small mb-1">Pedagogía</div>
              <FormControl
                type="text"
                name="pedagogia"
                value={respuestas.pedagogia}
                onChange={handleChange}
              />
            </FormGroup>
            </FormGroup>
          </Form>
          <br />
        </Col>

        <button onClick={enviarResultados} className="btn btn-primary">Enviar Resultados</button>
      </Row>
    </div>
  );

};

export default M4Ejercicio7;
